var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "app-container routes-box" },
    [
      _c(
        "div",
        { staticClass: "common-header" },
        [
          _c("common-header", {
            attrs: {
              headerList: [
                { label: "系统管理", url: "" },
                { label: "网关管理", url: "" }
              ]
            }
          })
        ],
        1
      ),
      _c("div", { staticClass: "routes-top" }, [
        _c(
          "div",
          { staticClass: "versionmange" },
          [
            _c("span", [_vm._v("当前版本号：" + _vm._s(_vm.lastversion))]),
            _c(
              "el-popconfirm",
              {
                attrs: { title: "确定提升当前版本号吗？" },
                on: {
                  onConfirm: function($event) {
                    return _vm.confirmaddversion(true)
                  },
                  onCancel: function($event) {
                    return _vm.confirmaddversion(false)
                  }
                }
              },
              [
                _c("input", {
                  staticClass: "btn btn-red add-btn",
                  attrs: {
                    slot: "reference",
                    type: "button",
                    value: "提升版本号"
                  },
                  slot: "reference"
                })
              ]
            ),
            _c("input", {
              staticClass: "btn btn-red add-btn",
              attrs: { type: "button", value: "新增" },
              on: { click: _vm.addTable }
            })
          ],
          1
        )
      ]),
      _c(
        "div",
        { staticClass: "routes-table" },
        [
          _c(
            "el-table",
            {
              directives: [
                {
                  name: "loading",
                  rawName: "v-loading",
                  value: _vm.loading,
                  expression: "loading"
                }
              ],
              ref: "multipleTable",
              staticStyle: { width: "100%" },
              attrs: {
                data: _vm.tableData,
                "tooltip-effect": "dark",
                border: "",
                "highlight-current-row": "",
                height: _vm.tableheight
              },
              on: {
                "header-dragend": _vm.headerdragend,
                "selection-change": _vm.handleSelectionChangeport
              }
            },
            [
              _c("template", { slot: "empty" }, [
                _c(
                  "div",
                  {
                    staticStyle: {
                      height: "100%",
                      width: "100%",
                      display: "flex",
                      "align-items": "center",
                      "justify-content": "center"
                    }
                  },
                  [
                    _c("no-data", {
                      attrs: { height: "400px", width: "400px" }
                    })
                  ],
                  1
                )
              ]),
              _c("el-table-column", {
                attrs: { type: "selection", fixed: "", width: "65" }
              }),
              _c("el-table-column", {
                attrs: {
                  prop: "routeId",
                  label: "路由编号",
                  "min-width": "80"
                },
                scopedSlots: _vm._u([
                  {
                    key: "default",
                    fn: function(scope) {
                      return [
                        _c(
                          "el-tooltip",
                          {
                            staticClass: "item",
                            attrs: { effect: "dark", placement: "top" }
                          },
                          [
                            _c("div", {
                              attrs: { slot: "content" },
                              domProps: {
                                innerHTML: _vm._s(
                                  _vm.ToBreak(scope.row.routeId)
                                )
                              },
                              slot: "content"
                            }),
                            _c("div", { staticClass: "line" }, [
                              _vm._v(_vm._s(scope.row.routeId))
                            ])
                          ]
                        )
                      ]
                    }
                  }
                ])
              }),
              _c("el-table-column", {
                attrs: {
                  prop: "routeUri",
                  label: "路由路径",
                  "min-width": "80"
                },
                scopedSlots: _vm._u([
                  {
                    key: "default",
                    fn: function(scope) {
                      return [
                        _c(
                          "el-tooltip",
                          {
                            staticClass: "item",
                            attrs: { effect: "dark", placement: "top" }
                          },
                          [
                            _c("div", {
                              attrs: { slot: "content" },
                              domProps: {
                                innerHTML: _vm._s(
                                  _vm.ToBreak(scope.row.routeUri)
                                )
                              },
                              slot: "content"
                            }),
                            _c("div", { staticClass: "line" }, [
                              _vm._v(_vm._s(scope.row.routeUri))
                            ])
                          ]
                        )
                      ]
                    }
                  }
                ])
              }),
              _c("el-table-column", {
                attrs: {
                  prop: "filters",
                  label: "过滤器字符串集合",
                  "min-width": "160"
                },
                scopedSlots: _vm._u([
                  {
                    key: "default",
                    fn: function(scope) {
                      return [
                        _c(
                          "el-tooltip",
                          {
                            staticClass: "item",
                            attrs: { effect: "dark", placement: "top" }
                          },
                          [
                            _c("div", {
                              attrs: { slot: "content" },
                              domProps: {
                                innerHTML: _vm._s(
                                  _vm.ToBreak(scope.row.filters)
                                )
                              },
                              slot: "content"
                            }),
                            _c("div", { staticClass: "line" }, [
                              _vm._v(_vm._s(scope.row.filters))
                            ])
                          ]
                        )
                      ]
                    }
                  }
                ])
              }),
              _c("el-table-column", {
                attrs: {
                  prop: "predicates",
                  label: "断言字符串集合",
                  "min-width": "160"
                },
                scopedSlots: _vm._u([
                  {
                    key: "default",
                    fn: function(scope) {
                      return [
                        _c(
                          "el-tooltip",
                          {
                            staticClass: "item",
                            attrs: { effect: "dark", placement: "top" }
                          },
                          [
                            _c("div", {
                              attrs: { slot: "content" },
                              domProps: {
                                innerHTML: _vm._s(
                                  _vm.ToBreak(scope.row.predicates)
                                )
                              },
                              slot: "content"
                            }),
                            _c("div", { staticClass: "line" }, [
                              _vm._v(_vm._s(scope.row.predicates))
                            ])
                          ]
                        )
                      ]
                    }
                  }
                ])
              }),
              _c("el-table-column", {
                attrs: {
                  prop: "createdBy",
                  label: "创建人",
                  "min-width": "80"
                },
                scopedSlots: _vm._u([
                  {
                    key: "default",
                    fn: function(scope) {
                      return [
                        _c(
                          "el-tooltip",
                          {
                            staticClass: "item",
                            attrs: { effect: "dark", placement: "top" }
                          },
                          [
                            _c("div", {
                              attrs: { slot: "content" },
                              domProps: {
                                innerHTML: _vm._s(
                                  _vm.ToBreak(scope.row.createdBy)
                                )
                              },
                              slot: "content"
                            }),
                            _c("div", { staticClass: "line" }, [
                              _vm._v(_vm._s(scope.row.createdBy))
                            ])
                          ]
                        )
                      ]
                    }
                  }
                ])
              }),
              _c("el-table-column", {
                attrs: {
                  prop: "createdTime",
                  label: "创建时间",
                  "min-width": "80"
                },
                scopedSlots: _vm._u([
                  {
                    key: "default",
                    fn: function(scope) {
                      return [
                        _c(
                          "el-tooltip",
                          {
                            staticClass: "item",
                            attrs: { effect: "dark", placement: "top" }
                          },
                          [
                            _c("div", {
                              attrs: { slot: "content" },
                              domProps: {
                                innerHTML: _vm._s(
                                  _vm.ToBreak(scope.row.createdTime)
                                )
                              },
                              slot: "content"
                            }),
                            _c("div", { staticClass: "line" }, [
                              _vm._v(_vm._s(scope.row.createdTime))
                            ])
                          ]
                        )
                      ]
                    }
                  }
                ])
              }),
              _c("el-table-column", {
                attrs: {
                  prop: "updatedBy",
                  label: "更新人",
                  "min-width": "80"
                },
                scopedSlots: _vm._u([
                  {
                    key: "default",
                    fn: function(scope) {
                      return [
                        _c(
                          "el-tooltip",
                          {
                            staticClass: "item",
                            attrs: { effect: "dark", placement: "top" }
                          },
                          [
                            _c("div", {
                              attrs: { slot: "content" },
                              domProps: {
                                innerHTML: _vm._s(
                                  _vm.ToBreak(scope.row.updatedBy)
                                )
                              },
                              slot: "content"
                            }),
                            _c("div", { staticClass: "line" }, [
                              _vm._v(_vm._s(scope.row.updatedBy))
                            ])
                          ]
                        )
                      ]
                    }
                  }
                ])
              }),
              _c("el-table-column", {
                attrs: {
                  prop: "updatedTime",
                  label: "更新时间",
                  "min-width": "80"
                },
                scopedSlots: _vm._u([
                  {
                    key: "default",
                    fn: function(scope) {
                      return [
                        _c(
                          "el-tooltip",
                          {
                            staticClass: "item",
                            attrs: { effect: "dark", placement: "top" }
                          },
                          [
                            _c("div", {
                              attrs: { slot: "content" },
                              domProps: {
                                innerHTML: _vm._s(
                                  _vm.ToBreak(scope.row.updatedTime)
                                )
                              },
                              slot: "content"
                            }),
                            _c("div", { staticClass: "line" }, [
                              _vm._v(_vm._s(scope.row.updatedTime))
                            ])
                          ]
                        )
                      ]
                    }
                  }
                ])
              }),
              _c("el-table-column", {
                attrs: { label: "操作", width: "65", fixed: "right" },
                scopedSlots: _vm._u([
                  {
                    key: "default",
                    fn: function(scope) {
                      return [
                        _c(
                          "el-popover",
                          {
                            ref: "routes-" + scope.row.id,
                            attrs: {
                              placement: "right",
                              width: "120",
                              trigger: "click",
                              "popper-class": "table-popper"
                            }
                          },
                          [
                            _c(
                              "div",
                              { staticClass: "op-tips" },
                              [
                                _c(
                                  "div",
                                  {
                                    staticClass: "op-item ",
                                    on: {
                                      click: function($event) {
                                        return _vm.editRoleDialog(scope, true)
                                      }
                                    }
                                  },
                                  [
                                    _c("operate-edit-icon", {
                                      staticClass: "svgOperateIcon"
                                    }),
                                    _vm._v(" 编辑")
                                  ],
                                  1
                                ),
                                _c(
                                  "el-popconfirm",
                                  {
                                    attrs: { title: "确定删除此条路由吗？" },
                                    on: {
                                      onConfirm: function($event) {
                                        return _vm.confirmdel(scope, true)
                                      },
                                      onCancel: function($event) {
                                        return _vm.confirmdel(scope, false)
                                      }
                                    }
                                  },
                                  [
                                    _c(
                                      "div",
                                      {
                                        staticClass: "op-item ",
                                        attrs: { slot: "reference" },
                                        slot: "reference"
                                      },
                                      [
                                        _c("delIcon", {
                                          staticClass: "svgOperateIcon",
                                          staticStyle: {
                                            "margin-bottom": "1px"
                                          }
                                        }),
                                        _vm._v(" 删除")
                                      ],
                                      1
                                    )
                                  ]
                                )
                              ],
                              1
                            ),
                            _c("operate", {
                              staticClass: "operate-icon",
                              attrs: { slot: "reference" },
                              slot: "reference"
                            })
                          ],
                          1
                        )
                      ]
                    }
                  }
                ])
              })
            ],
            2
          ),
          _c("div", { staticClass: "routes-footer" }, [
            _c(
              "div",
              { staticClass: "footer-right" },
              [
                _vm.pageshow
                  ? _c("el-pagination", {
                      attrs: {
                        background: "",
                        layout: "total, sizes, prev, pager, next, jumper",
                        total: _vm.totalrecord,
                        "hide-on-single-page": false,
                        "page-sizes": [10, 20, 50, 100, 1000, 2000],
                        "page-size": 10,
                        "current-page": _vm.filtratedata.pageNum
                      },
                      on: {
                        "update:currentPage": function($event) {
                          return _vm.$set(_vm.filtratedata, "pageNum", $event)
                        },
                        "update:current-page": function($event) {
                          return _vm.$set(_vm.filtratedata, "pageNum", $event)
                        },
                        "size-change": _vm.handleSizeChange,
                        "current-change": _vm.handleCurrentChange
                      }
                    })
                  : _vm._e()
              ],
              1
            )
          ])
        ],
        1
      ),
      _vm.showRoleEdit
        ? _c(
            "el-dialog",
            {
              directives: [
                { name: "el-drag-dialog", rawName: "v-el-drag-dialog" }
              ],
              staticClass: "dialog_footer_btn",
              attrs: {
                width: "600px",
                title: _vm.ifAddEdit ? "编辑路由" : "新增路由",
                visible: _vm.showRoleEdit
              },
              on: {
                "update:visible": function($event) {
                  _vm.showRoleEdit = $event
                }
              }
            },
            [
              _c("add-route", {
                attrs: {
                  ifSysEdit: _vm.ifAddEdit,
                  systemdata: _vm.editPermission,
                  systemlist: _vm.systemlist
                },
                on: { RoutesSubmit: _vm.RoutesSubmit }
              })
            ],
            1
          )
        : _vm._e()
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }